var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.82667 10.3818C6.74667 14.1551 9.84 17.2484 13.6133 19.1684L16.5467 16.2351C16.92 15.8618 17.44 15.7551 17.9067 15.9018C19.4 16.3951 21 16.6618 22.6667 16.6618C23.0203 16.6618 23.3594 16.8023 23.6095 17.0523C23.8595 17.3024 24 17.6415 24 17.9951V22.6618C24 23.0154 23.8595 23.3545 23.6095 23.6046C23.3594 23.8546 23.0203 23.9951 22.6667 23.9951C16.6551 23.9951 10.8897 21.607 6.63891 17.3562C2.38809 13.1054 0 7.34002 0 1.32845C0 0.974829 0.140476 0.63569 0.390524 0.385641C0.640573 0.135593 0.979711 -0.00488281 1.33333 -0.00488281H6C6.35362 -0.00488281 6.69276 0.135593 6.94281 0.385641C7.19286 0.63569 7.33333 0.974829 7.33333 1.32845C7.33333 2.99512 7.6 4.59512 8.09333 6.08845C8.24 6.55512 8.13333 7.07512 7.76 7.44845L4.82667 10.3818Z",
    fill: "#F6F6F6"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone);
export default __webpack_public_path__ + "static/media/phone.e24fd83fd69151239946089860451d99.svg";
export { ForwardRef as ReactComponent };